import template from './upcomingEditionsSelector.html';

function UpcomingEditionsSelectorController(
  $log,
  $q,
  Edition,
  moment,
  Publication,
  PublicationSection
) {
  const $ctrl = this;

  const updateSelectedValue = function update(editionTime) {
    $ctrl.editionTime = editionTime;
    $ctrl.updateChange(+moment($ctrl.editionTime).unix());
  };

  const loadUpcomingEditions = function load() {
    Publication.get($ctrl.publicationId)
      .then((data) => {
        $ctrl.publication = data;
        $ctrl.sections = data.sections;
        if ($ctrl.pitch) {
          if ($ctrl.pitch.currentEditionTime) {
            $ctrl.backlogSelected = false;
            Edition.get($ctrl.pitch.currentEdition)
              .then((editionData) => {
                $ctrl.section = $ctrl.sections.find(section => (
                  section.id === editionData.sectionId));

                $ctrl.getUpcomingEditions()
                  .then(() => {
                    $ctrl.backlogSelected = false;

                    const editionDate = moment.unix($ctrl.pitch.currentEditionTime).valueOf();
                    const currentEditionIndex = $ctrl.upcomingEditionsBySection[$ctrl.section.id]
                      .findIndex(publicationTime => publicationTime === editionDate);

                    if (currentEditionIndex > -1) {
                      const selectedEditionTime =
                        $ctrl.upcomingEditionsBySection[$ctrl.section.id][currentEditionIndex];
                      updateSelectedValue(selectedEditionTime);
                      $ctrl.updateStartDate($ctrl.upcomingEditionsBySection[$ctrl.section.id][0]);
                    } else {
                      updateSelectedValue(editionDate);
                      const selectedEditionTime =
                        $ctrl.upcomingEditionsBySection[$ctrl.section.id][0];
                      $ctrl.updateStartDate(selectedEditionTime);
                    }

                    $ctrl.render = true;
                  });
              });
          } else {
            const { publicationId } = $ctrl.pitch;
            const sectionId = $ctrl.pitch.currentEdition.split(publicationId)[1].slice(1, -8);

            $ctrl.section = $ctrl.sections.find(section => section.id === sectionId);
            $ctrl.getUpcomingEditions()
              .then(() => {
                $ctrl.render = true;
              });
          }
        } else {
          $ctrl.section = $ctrl.existingPublication && $ctrl.existingPublication.sectionId ?
            $ctrl.sections.find(sec => $ctrl.existingPublication.sectionId === sec.id) :
            $ctrl.sections[0];
          $ctrl.getUpcomingEditions()
            .then(() => {
              $ctrl.render = true;
            });
        }
      }, () => {
        $log.error('Error getting publication in upcoming editions selector');
      });
  };

  $ctrl.$onInit = () => {
    $ctrl.upcomingEditionsBySection = {};
    $ctrl.moment = moment;
    $ctrl.updateStartDate(moment());
    $ctrl.endDate = moment().add(2, 'y');
    $ctrl.render = false;
    $ctrl.existingPublication = $ctrl.selectedPublications
      ? $ctrl.selectedPublications.find(pub => pub.id === $ctrl.publicationId)
      : null;
    loadUpcomingEditions();
  };

  $ctrl.updateChange = (editionTime) => {
    const editionTimeUpdate = $ctrl.backlogSelected ? null : editionTime;
    const targetChange = {
      publicationId: $ctrl.publication.id,
      sectionId: $ctrl.section.id,
      editionTime: editionTimeUpdate || null
    };

    // The only purpose of this property is to retain the value
    // of the edition time, if the user switches sections
    $ctrl.currentEditionTime = +moment.unix(editionTime);

    $ctrl.update({ targetChange });
  };

  $ctrl.switchEditionsList = (backlog = false) => {
    const upcomingEditions = $ctrl.upcomingEditionsBySection[$ctrl.section.id];

    if (upcomingEditions.length > 0) {
      $ctrl.backlogSelected = backlog;

      const [nextEdition] = upcomingEditions;
      // If the current edition time is valid for the new section, retain it
      $ctrl.editionTime = upcomingEditions.includes($ctrl.currentEditionTime)
        ? $ctrl.currentEditionTime
        : nextEdition;

      $ctrl.updateStartDate(nextEdition);
      $ctrl.updateChange(+moment($ctrl.editionTime).unix());
      $ctrl.getUpcomingEditions();
    } else {
      $ctrl.backlogSelected = true;
      $ctrl.editionTime = null;
    }
  };

  $ctrl.updateStartDate = (date) => {
    $ctrl.startDate = date;
  };

  $ctrl.getUpcomingEditions = () => {
    const deferred = $q.defer();
    $ctrl.render = false;

    const startDate = +moment($ctrl.startDate).unix();
    const endDate = +moment($ctrl.endDate).unix();
    $ctrl.publication.getEditionTimes({
      startDate,
      endDate
    }).then((response) => {
      // Organizing upcoming edition times by their section's name
      response.forEach((value) => {
        const val = value;
        val.publicationTime = +moment.unix(val.publicationTime);
        val.sections.forEach((section) => {
          $ctrl.upcomingEditionsBySection[section] = $ctrl.upcomingEditionsBySection[section] || [];
          $ctrl.upcomingEditionsBySection[section].push(val.publicationTime);
        });
      });

      // Creating all sections' new instances
      const sections = Object.keys($ctrl.upcomingEditionsBySection)
        .map(section => new PublicationSection({
          id: section,
          publicationId: this.publication.id
        }));

      /* Further filtering out the edition times based on closed/finalized, have to perform
       * this because closed/finalized properties are not available on upcoming editions
       */
      const sectionEditionsRequests = sections.map(section =>
        section.getEditions({
          startDate,
          includeTrailingStubs: true,
          numEditions: $ctrl.upcomingEditionsBySection[section.id].length
        }));

      $q.all(sectionEditionsRequests)
        .then((results) => {
          results.forEach((editions, i) => {
            editions.forEach((edition) => {
              if (edition.closed || edition.finalized) {
                const index = $ctrl.upcomingEditionsBySection[sections[i].id]
                  .indexOf(edition.publicationTime);
                $ctrl.upcomingEditionsBySection[sections[i].id].splice(index, 1);
              }
            });
          });
          // Set initial values after filtering out upcoming editions
          if (!($ctrl.pitch && $ctrl.pitch.currentEditionTime)) {
            const selectedSectionEditions = $ctrl.upcomingEditionsBySection[$ctrl.section.id];

            if (selectedSectionEditions) {
              $ctrl.backlogSelected = false;
              const existingEditionTime = $ctrl.existingPublication
                && $ctrl.existingPublication.editionTime;

              $ctrl.editionTime = existingEditionTime
                ? +moment.unix($ctrl.existingPublication.editionTime)
                : $ctrl.upcomingEditionsBySection[$ctrl.section.id][0];

              if (!existingEditionTime) {
                $ctrl.updateStartDate($ctrl.editionTime);
              }
              $ctrl.updateChange(+moment($ctrl.editionTime).unix());
            } else {
              $ctrl.backlogSelected = true;
            }
          }
          $ctrl.render = true;
          deferred.resolve($ctrl.upcomingEditionsBySection);
        });
    });

    return deferred.promise;
  };
}

const controllerArray = [
  '$log',
  '$q',
  'Edition',
  'moment',
  'Publication',
  'PublicationSection',
  UpcomingEditionsSelectorController
];

const component = {
  template,
  bindings: {
    // (optional) for initializing to correct edition and section values
    pitch: '<',

    // (required) based on which upcoming editions will be fetched
    publicationId: '<',

    // method to bind, will send an object of publicationId & selected editionTime
    update: '&',

    // pass in the class to be applied to the select element
    styleClass: '@',

    // pass in the name of the parent component in order to set the layout correctly
    container: '@',
    selectedPublications: '<'
  },
  controller: 'UpcomingEditionsController'
};

export default function (ngModule) {
  ngModule.component('upcomingEditionsSelector', component);
  ngModule.controller('UpcomingEditionsController', controllerArray);
}
